import { edgelessToolbarI18nT } from '@blocksuite/affine-shared/services';
import { SeniorToolExtension } from '@blocksuite/affine-widget-edgeless-toolbar';
import { html } from 'lit';

export const connectorSeniorTool = SeniorToolExtension(
  'connector',
  ({ block }) => {
    return {
      name: edgelessToolbarI18nT('toolbar.connector'),
      content: html`<edgeless-connector-tool-button
        .edgeless=${block}
      ></edgeless-connector-tool-button>`,
      priority: 80,
    };
  }
);
